module.exports = __webpack_public_path__ + "img/icon-calendar.1a7e3c27.svg";